// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Company Info*/
#fc-component{
    width: 60%;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 12.5%;
    /*margin-top: 50px;*/
}

#company-info-title{
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;

    font-size: 3em;
    font-weight: bold;
    color: #012D26;

}

#company-info-description{
    display: flex;
    width: 100%;
    height: 150px;
    margin-top: 20px;

    color: #012D26;
    font-size: 1.5em;

}

#company-info-button{
    width: 22%;
    min-height: 50px;
    height: 50px;

    font-size: 1.2em;
    font-weight: lighter;

    color: #ffffff;
    background-color: #01483F;
    border: none;
    border-radius: 25px;
}

/*Feature Info*/
#feature-info-header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 15px;

    /*border: 1px solid black;*/
}

#feature-info-title{
    text-align: center;
    font-size: 2em;
    color: #012D26;
    font-weight: bold;
    margin-bottom: 5px;

    /*border: 1px solid black;*/
}

#feature-info-sub-title{
    font-size: 1.3em;
    color: #E65924;
    margin-bottom: 5%;
    font-weight: bold;

    /*border: 1px solid black;*/
}

#feature-info-pictures-container{
    display: flex;
    justify-content: center;
    width: 75%;
    height: 315px;

    /*border: 1px solid black;*/
}
.feature-info-component{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 33.333%;
    min-width: 300px;
    max-width: 315px;
    margin-left: 75px;
    margin-right: 75px;

    max-height: 315px;
    height: 100%;
}

.feature-info-image{
    width: 100%;
    height: 100%;
    margin-left: 7.5%;
    margin-right: 7.5%;
    display: flex;

    /*border: 1px solid black;*/
}

.feature-info-image-description{
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;

    text-align: center;
    font-size: 1.2em;
    font-weight: 750;
    color: #01483F;
    /*border: 1px solid black;*/
}

/*Vision And Mission*/
#vm-container{
    width: 100%;
    height: 400px;
    background-color: #01483F;
    color: #f4f4f4;

    /*border: 1px solid aqua;*/
}

#value-section{
    width: 75%;
    height: 80%;
    margin-left: 12.5%;
    margin-right: 12.5%;
    display: flex;

    /*border: 1px solid white;*/
}

.value-component-container{
    width: 33.333%;
    height: 100%;
    padding-top: 15px;
    /*border: 1px solid white;*/
}

.value-component-image-container{
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    padding: 7% 0;
    display: flex;
    justify-content: center;
    /*border: 1px solid white;*/
}

.value-component-image{
    width: 100%;
    min-width: 70px;
    max-width: 70px;

    height: 85px;

    /*border: 1px solid white;*/
}

.value-component-text-container{
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
    height: 63%;

    text-align: center;
    /*border: 1px solid white;*/
}

.value-component-text-title{
    font-size: 1.5em;
}

.value-component-text-description{
    margin-top: 7%;
    font-size: 1em;
}

.value-component-underline{
    width: 22%;
    display: flex;

    margin-top: 2px;
    margin-left: 39%;
    margin-right: 39%;
    height: 4px;


    background-color: #E8DE00;
}

#vm-button-section{
    height: 15%;
    width: 100%;
    display: flex;
    justify-content: center;

    /*border: 1px solid white;*/
}

#vm-button{
    width: 27%;
    max-width: 1000px;
    height: 60%;
    background: #E8DE00;
    outline: none;
    border: transparent;
    border-radius: 25px;

    font-family: raleway,'sans-serif';
    font-weight: 500;
    color: #012D26;
    font-size: 1.05em;
    /*background-color: '';*/
}

#projects-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 800px;
}

#projects-title{
    width: 100%;
    max-width: 1000px;
    height: 37px;

    display: flex;
    align-items: center;

    font-size: 2.5em;
    font-weight: 680;
    color: #01483F;
    margin-bottom: 5px;
    /*border: 1px solid black;*/
}

#projects-component-container{
    width: 100%;
    max-width: 1000px;
    height: 90%;
    display: flex;

    /*border: 1px solid black;*/
}

.projects-component-row{
    width: 33.333%;
    height: 100%;
    /*border: 1px solid aqua;*/
}

.projects-component-image-container-m{
    height: 33.333%;
    width: 100%;

    /*border: 1px solid black;*/
}

.projects-component-image-container-l{
    height: 66.667%;
    width: 100%;

    /*border: 1px solid #01483F;*/
}

.projects-component-image{
    position: relative;
    width: 97.5%;
    height: 97.5%;
    /*padding-left: 1.25%;*/
    /*padding-right: 1.25%;*/
    /*top: 1.25%;*/
    /*bottom: 1.25%;*/

    /*border: 1px solid black;*/
}


@media screen and (min-width: 2000px){
    #fc-component{
        padding-top: 50px;
        width: 50%;
        min-height: 200px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 12.5%;
        /*border: 1px solid black;*/
    }

    #company-info-title{
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;

        font-size: 3vw;
        font-weight: bold;
        color: #012D26;

        /*border: 1px solid black;*/
    }

    #company-info-description{
        display: flex;
        width: 100%;
        height: auto;
        margin-top: 30px;
        color: #012D26;
        font-size: 1.5vw;
    }

    #company-info-button{
        width: 25%;
        height: 4vh;
        max-width: 3000px;
        font-size: 1.2vw;
        font-weight: lighter;

        margin: 2% 0;
        color: #ffffff;
        background-color: #01483F;
        border: none;
        border-radius: 50px;
    }
}

@media screen and (max-width: 1100px){
    #vm-container{
        width: 100%;
        height: auto;
        background-color: #01483F;
        color: #f4f4f4;

        /*border: 1px solid aqua;*/
    }

    #value-section{
        width: 75%;
        height: 85%;
        margin-left: 12.5%;
        margin-right: 12.5%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* border: 1px solid white; */
    }

    .value-component-container{
        width: 100%;
        height: 100%;
        padding-top: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

    .value-component-image-container{
        width: 85px;
        height: 95px;
        padding: 15px 0 0 0;
        /* border: 1px solid white; */
    }

    .value-component-image{
        width: 100%;
        height: 100%;
    }

    .value-component-text-container{
        width: 80%;
        margin-left: 10%;
        margin-right: 10%;
        height: 63%;
        text-align: center;
    }

    .value-component-text-title{
        font-size: 1.5em;
    }

    .value-component-text-description{
        margin-top: 20px;
        font-size: 1em;
    }

    .value-component-underline{
        width: 22%;
        display: flex;

        margin-top: 7px;
        margin-left: 39%;
        margin-right: 39%;
        height: 4px;


        background-color: #E8DE00;
    }

    #vm-button-section{
        margin: 50px 0;
        height: 15%;
        width: 100%;
        display: flex;
        justify-content: center;

        /*border: 1px solid white;*/
    }

    #vm-button{
        width: 90%;
        min-width: auto;
        max-width: none;
        height: 60%;
        min-height: 30px;
        background: #E8DE00;
        outline: none;
        border: transparent;
        border-radius: 25px;

        font-family: raleway,'sans-serif';
        font-weight: 500;
        color: #012D26;
        font-size: 0.8em;
        /*background-color: '';*/
    }

    #projects-container{
        width: 100%;
        max-width: none;
        height: auto;
        padding: 0;
        margin: 0;
    }

    #projects-title{
        width: 95%;
        margin: 10px 0;
        font-size: 1.3em;
        height: auto;
    }

    #projects-component-container{
        width: 100%;
        height: auto;
        display: flex;
        flex-direction: column;
    }

    .projects-component-row{
        width: 100%;
        height: 100%;
        /*border: 1px solid aqua;*/
    }

    .projects-component-image-container-m{
        height: 33.333%;
        width: 90%;
        margin: 0 5%;
        /*border: 1px solid black;*/
    }

    .projects-component-image-container-l{
        height: 66.667%;
        width: 90%;
        margin: 0 5%;
        /*border: 1px solid #01483F;*/
    }

    .projects-component-image{
        position: static;
        width: 97.5%;
        height: 97.5%;
        margin: 15px 0;
        /*padding-left: 1.25%;*/
        /*padding-right: 1.25%;*/
        /*top: 1.25%;*/
        /*bottom: 1.25%;*/
        /*border: 1px solid black;*/
    }


    #feature-info{
        width: 100%;
        height: auto;
        padding: 0;
        margin: 0;
    }

    #feature-info-header{
        width: 90%;
        height: auto;
        margin: 2vh 5% 10px 5%;
        display: flex;
        justify-content: flex-start;
    }

    #feature-info-title{
        font-size: 1.7em;
        text-align: left;
    }

    #feature-info-sub-title{
        font-size: 1.3em;
        margin: 0;
    }

    #feature-info-pictures-container{
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        height: auto;
    }

    .feature-info-component{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 90%;
        max-width: none;
        min-width: auto;
        margin: 0 5%;
        height: auto;
        max-height: none;
    }

    .feature-info-image{
        width: 75%;
        display: flex;
        margin-top: 15px;
        /*border: 1px solid black;*/
    }

    .feature-info-image-description{
        width: 100%;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: center;

        text-align: center;
        font-size: 1em;
        font-weight: 750;
        color: #01483F;
        /*border: 1px solid black;*/
    }

    #company-info-button{
        font-size: 1em;
        width: 70%;
        margin: 2% 15%;
        min-width: auto;
        max-width: none;
        max-height: 32px;
        min-height: auto;
    }
}

@media screen and (max-width: 450px){
    .value-component-image-container{
        width: 40px;
        height: 45px;
        min-width: auto;
        max-width: none;
    }

    .value-component-image{
        min-width: auto;
        max-width: none;
        width: 100%;
        height: 100%;
    }

    .value-component-text-title{
        margin-top: 5px;
        font-size: 1.1em;
    }

    .value-component-text-description{
        margin-top: 20px;
        font-size: 1em;
    }

    #vm-button{
        min-height: auto;
        max-height: none;
        height: 30px;
        font-size: 1em;
        /*background-color: '';*/
    }

    #company-info-button {
        font-size: 0.8em;
        height: 30px;
    }
    #projects-title{
        font-size: 1.1em;
        height: auto;
    }
    #feature-info-title{
        font-size: 1.5em;
        text-align: center;
    }
    #feature-info-sub-title{
        font-size: 1.2em;
        text-align: center;
    }
    .feature-info-image-description{
        font-size: 1em;
        margin-bottom: 10px;
        color: #01483F;
    }
}`, "",{"version":3,"sources":["webpack://./src/App/Page/Home/style.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;;IAEnB,cAAc;IACd,iBAAiB;IACjB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,gBAAgB;;IAEhB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,YAAY;;IAEZ,gBAAgB;IAChB,oBAAoB;;IAEpB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;IAEhB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,kBAAkB;;IAElB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;;IAEjB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,UAAU;IACV,aAAa;;IAEb,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;;IAElB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;;IAEb,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,qBAAqB;AACrB;IACI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,cAAc;;IAEd,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;;IAEb,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;;IAEf,YAAY;;IAEZ,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;;IAEX,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,aAAa;;IAEb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;;;IAGX,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,aAAa;IACb,uBAAuB;;IAEvB,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;;IAEnB,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;;IAEZ,aAAa;IACb,mBAAmB;;IAEnB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,aAAa;;IAEb,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,WAAW;;IAEX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,WAAW;;IAEX,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,wBAAwB;IACxB,cAAc;IACd,iBAAiB;;IAEjB,2BAA2B;AAC/B;;;AAGA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;;QAEnB,cAAc;QACd,iBAAiB;QACjB,cAAc;;QAEd,2BAA2B;IAC/B;;IAEA;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;;QAEpB,YAAY;QACZ,cAAc;QACd,yBAAyB;QACzB,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,yBAAyB;QACzB,cAAc;;QAEd,0BAA0B;IAC9B;;IAEA;QACI,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,6BAA6B;IACjC;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,aAAa;;QAEb,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;;;QAGX,yBAAyB;IAC7B;;IAEA;QACI,cAAc;QACd,WAAW;QACX,WAAW;QACX,aAAa;QACb,uBAAuB;;QAEvB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,eAAe;QACf,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,mBAAmB;;QAEnB,iCAAiC;QACjC,gBAAgB;QAChB,cAAc;QACd,gBAAgB;QAChB,wBAAwB;IAC5B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,UAAU;QACV,SAAS;IACb;;IAEA;QACI,UAAU;QACV,cAAc;QACd,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,eAAe;QACf,UAAU;QACV,YAAY;QACZ,2BAA2B;IAC/B;;IAEA;QACI,eAAe;QACf,UAAU;QACV,YAAY;QACZ,6BAA6B;IACjC;;IAEA;QACI,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,cAAc;QACd,uBAAuB;QACvB,wBAAwB;QACxB,cAAc;QACd,iBAAiB;QACjB,2BAA2B;IAC/B;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,UAAU;QACV,SAAS;IACb;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,sBAAsB;QACtB,aAAa;QACb,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,sBAAsB;QACtB,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,UAAU;QACV,eAAe;QACf,eAAe;QACf,YAAY;QACZ,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,aAAa;QACb,gBAAgB;QAChB,2BAA2B;IAC/B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;;QAEnB,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,cAAc;QACd,2BAA2B;IAC/B;;IAEA;QACI,cAAc;QACd,UAAU;QACV,cAAc;QACd,eAAe;QACf,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;QACZ,cAAc;QACd,wBAAwB;IAC5B;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,YAAY;IAChB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,mBAAmB;QACnB,cAAc;IAClB;AACJ","sourcesContent":["/*Company Info*/\r\n#fc-component{\r\n    width: 60%;\r\n    height: 350px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    margin-left: 12.5%;\r\n    /*margin-top: 50px;*/\r\n}\r\n\r\n#company-info-title{\r\n    width: 100%;\r\n    height: auto;\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    font-size: 3em;\r\n    font-weight: bold;\r\n    color: #012D26;\r\n\r\n}\r\n\r\n#company-info-description{\r\n    display: flex;\r\n    width: 100%;\r\n    height: 150px;\r\n    margin-top: 20px;\r\n\r\n    color: #012D26;\r\n    font-size: 1.5em;\r\n\r\n}\r\n\r\n#company-info-button{\r\n    width: 22%;\r\n    min-height: 50px;\r\n    height: 50px;\r\n\r\n    font-size: 1.2em;\r\n    font-weight: lighter;\r\n\r\n    color: #ffffff;\r\n    background-color: #01483F;\r\n    border: none;\r\n    border-radius: 25px;\r\n}\r\n\r\n/*Feature Info*/\r\n#feature-info-header{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 15px;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n#feature-info-title{\r\n    text-align: center;\r\n    font-size: 2em;\r\n    color: #012D26;\r\n    font-weight: bold;\r\n    margin-bottom: 5px;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n#feature-info-sub-title{\r\n    font-size: 1.3em;\r\n    color: #E65924;\r\n    margin-bottom: 5%;\r\n    font-weight: bold;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n#feature-info-pictures-container{\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 75%;\r\n    height: 315px;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n.feature-info-component{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 33.333%;\r\n    min-width: 300px;\r\n    max-width: 315px;\r\n    margin-left: 75px;\r\n    margin-right: 75px;\r\n\r\n    max-height: 315px;\r\n    height: 100%;\r\n}\r\n\r\n.feature-info-image{\r\n    width: 100%;\r\n    height: 100%;\r\n    margin-left: 7.5%;\r\n    margin-right: 7.5%;\r\n    display: flex;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.feature-info-image-description{\r\n    width: 100%;\r\n    height: 70px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    text-align: center;\r\n    font-size: 1.2em;\r\n    font-weight: 750;\r\n    color: #01483F;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n/*Vision And Mission*/\r\n#vm-container{\r\n    width: 100%;\r\n    height: 400px;\r\n    background-color: #01483F;\r\n    color: #f4f4f4;\r\n\r\n    /*border: 1px solid aqua;*/\r\n}\r\n\r\n#value-section{\r\n    width: 75%;\r\n    height: 80%;\r\n    margin-left: 12.5%;\r\n    margin-right: 12.5%;\r\n    display: flex;\r\n\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n.value-component-container{\r\n    width: 33.333%;\r\n    height: 100%;\r\n    padding-top: 15px;\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n.value-component-image-container{\r\n    width: 80%;\r\n    margin-left: 10%;\r\n    margin-right: 10%;\r\n    padding: 7% 0;\r\n    display: flex;\r\n    justify-content: center;\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n.value-component-image{\r\n    width: 100%;\r\n    min-width: 70px;\r\n    max-width: 70px;\r\n\r\n    height: 85px;\r\n\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n.value-component-text-container{\r\n    width: 80%;\r\n    margin-left: 10%;\r\n    margin-right: 10%;\r\n    height: 63%;\r\n\r\n    text-align: center;\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n.value-component-text-title{\r\n    font-size: 1.5em;\r\n}\r\n\r\n.value-component-text-description{\r\n    margin-top: 7%;\r\n    font-size: 1em;\r\n}\r\n\r\n.value-component-underline{\r\n    width: 22%;\r\n    display: flex;\r\n\r\n    margin-top: 2px;\r\n    margin-left: 39%;\r\n    margin-right: 39%;\r\n    height: 4px;\r\n\r\n\r\n    background-color: #E8DE00;\r\n}\r\n\r\n#vm-button-section{\r\n    height: 15%;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n\r\n    /*border: 1px solid white;*/\r\n}\r\n\r\n#vm-button{\r\n    width: 27%;\r\n    max-width: 1000px;\r\n    height: 60%;\r\n    background: #E8DE00;\r\n    outline: none;\r\n    border: transparent;\r\n    border-radius: 25px;\r\n\r\n    font-family: raleway,'sans-serif';\r\n    font-weight: 500;\r\n    color: #012D26;\r\n    font-size: 1.05em;\r\n    /*background-color: '';*/\r\n}\r\n\r\n#projects-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 800px;\r\n}\r\n\r\n#projects-title{\r\n    width: 100%;\r\n    max-width: 1000px;\r\n    height: 37px;\r\n\r\n    display: flex;\r\n    align-items: center;\r\n\r\n    font-size: 2.5em;\r\n    font-weight: 680;\r\n    color: #01483F;\r\n    margin-bottom: 5px;\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n#projects-component-container{\r\n    width: 100%;\r\n    max-width: 1000px;\r\n    height: 90%;\r\n    display: flex;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.projects-component-row{\r\n    width: 33.333%;\r\n    height: 100%;\r\n    /*border: 1px solid aqua;*/\r\n}\r\n\r\n.projects-component-image-container-m{\r\n    height: 33.333%;\r\n    width: 100%;\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n.projects-component-image-container-l{\r\n    height: 66.667%;\r\n    width: 100%;\r\n\r\n    /*border: 1px solid #01483F;*/\r\n}\r\n\r\n.projects-component-image{\r\n    position: relative;\r\n    width: 97.5%;\r\n    height: 97.5%;\r\n    /*padding-left: 1.25%;*/\r\n    /*padding-right: 1.25%;*/\r\n    /*top: 1.25%;*/\r\n    /*bottom: 1.25%;*/\r\n\r\n    /*border: 1px solid black;*/\r\n}\r\n\r\n\r\n@media screen and (min-width: 2000px){\r\n    #fc-component{\r\n        padding-top: 50px;\r\n        width: 50%;\r\n        min-height: 200px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        margin-left: 12.5%;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    #company-info-title{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        font-size: 3vw;\r\n        font-weight: bold;\r\n        color: #012D26;\r\n\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    #company-info-description{\r\n        display: flex;\r\n        width: 100%;\r\n        height: auto;\r\n        margin-top: 30px;\r\n        color: #012D26;\r\n        font-size: 1.5vw;\r\n    }\r\n\r\n    #company-info-button{\r\n        width: 25%;\r\n        height: 4vh;\r\n        max-width: 3000px;\r\n        font-size: 1.2vw;\r\n        font-weight: lighter;\r\n\r\n        margin: 2% 0;\r\n        color: #ffffff;\r\n        background-color: #01483F;\r\n        border: none;\r\n        border-radius: 50px;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 1100px){\r\n    #vm-container{\r\n        width: 100%;\r\n        height: auto;\r\n        background-color: #01483F;\r\n        color: #f4f4f4;\r\n\r\n        /*border: 1px solid aqua;*/\r\n    }\r\n\r\n    #value-section{\r\n        width: 75%;\r\n        height: 85%;\r\n        margin-left: 12.5%;\r\n        margin-right: 12.5%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        /* border: 1px solid white; */\r\n    }\r\n\r\n    .value-component-container{\r\n        width: 100%;\r\n        height: 100%;\r\n        padding-top: 15px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .value-component-image-container{\r\n        width: 85px;\r\n        height: 95px;\r\n        padding: 15px 0 0 0;\r\n        /* border: 1px solid white; */\r\n    }\r\n\r\n    .value-component-image{\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    .value-component-text-container{\r\n        width: 80%;\r\n        margin-left: 10%;\r\n        margin-right: 10%;\r\n        height: 63%;\r\n        text-align: center;\r\n    }\r\n\r\n    .value-component-text-title{\r\n        font-size: 1.5em;\r\n    }\r\n\r\n    .value-component-text-description{\r\n        margin-top: 20px;\r\n        font-size: 1em;\r\n    }\r\n\r\n    .value-component-underline{\r\n        width: 22%;\r\n        display: flex;\r\n\r\n        margin-top: 7px;\r\n        margin-left: 39%;\r\n        margin-right: 39%;\r\n        height: 4px;\r\n\r\n\r\n        background-color: #E8DE00;\r\n    }\r\n\r\n    #vm-button-section{\r\n        margin: 50px 0;\r\n        height: 15%;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: center;\r\n\r\n        /*border: 1px solid white;*/\r\n    }\r\n\r\n    #vm-button{\r\n        width: 90%;\r\n        min-width: auto;\r\n        max-width: none;\r\n        height: 60%;\r\n        min-height: 30px;\r\n        background: #E8DE00;\r\n        outline: none;\r\n        border: transparent;\r\n        border-radius: 25px;\r\n\r\n        font-family: raleway,'sans-serif';\r\n        font-weight: 500;\r\n        color: #012D26;\r\n        font-size: 0.8em;\r\n        /*background-color: '';*/\r\n    }\r\n\r\n    #projects-container{\r\n        width: 100%;\r\n        max-width: none;\r\n        height: auto;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    #projects-title{\r\n        width: 95%;\r\n        margin: 10px 0;\r\n        font-size: 1.3em;\r\n        height: auto;\r\n    }\r\n\r\n    #projects-component-container{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n\r\n    .projects-component-row{\r\n        width: 100%;\r\n        height: 100%;\r\n        /*border: 1px solid aqua;*/\r\n    }\r\n\r\n    .projects-component-image-container-m{\r\n        height: 33.333%;\r\n        width: 90%;\r\n        margin: 0 5%;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .projects-component-image-container-l{\r\n        height: 66.667%;\r\n        width: 90%;\r\n        margin: 0 5%;\r\n        /*border: 1px solid #01483F;*/\r\n    }\r\n\r\n    .projects-component-image{\r\n        position: static;\r\n        width: 97.5%;\r\n        height: 97.5%;\r\n        margin: 15px 0;\r\n        /*padding-left: 1.25%;*/\r\n        /*padding-right: 1.25%;*/\r\n        /*top: 1.25%;*/\r\n        /*bottom: 1.25%;*/\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n\r\n    #feature-info{\r\n        width: 100%;\r\n        height: auto;\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    #feature-info-header{\r\n        width: 90%;\r\n        height: auto;\r\n        margin: 2vh 5% 10px 5%;\r\n        display: flex;\r\n        justify-content: flex-start;\r\n    }\r\n\r\n    #feature-info-title{\r\n        font-size: 1.7em;\r\n        text-align: left;\r\n    }\r\n\r\n    #feature-info-sub-title{\r\n        font-size: 1.3em;\r\n        margin: 0;\r\n    }\r\n\r\n    #feature-info-pictures-container{\r\n        display: flex;\r\n        justify-content: center;\r\n        flex-direction: column;\r\n        width: 100%;\r\n        height: auto;\r\n    }\r\n\r\n    .feature-info-component{\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n        width: 90%;\r\n        max-width: none;\r\n        min-width: auto;\r\n        margin: 0 5%;\r\n        height: auto;\r\n        max-height: none;\r\n    }\r\n\r\n    .feature-info-image{\r\n        width: 75%;\r\n        display: flex;\r\n        margin-top: 15px;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    .feature-info-image-description{\r\n        width: 100%;\r\n        height: auto;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        text-align: center;\r\n        font-size: 1em;\r\n        font-weight: 750;\r\n        color: #01483F;\r\n        /*border: 1px solid black;*/\r\n    }\r\n\r\n    #company-info-button{\r\n        font-size: 1em;\r\n        width: 70%;\r\n        margin: 2% 15%;\r\n        min-width: auto;\r\n        max-width: none;\r\n        max-height: 32px;\r\n        min-height: auto;\r\n    }\r\n}\r\n\r\n@media screen and (max-width: 450px){\r\n    .value-component-image-container{\r\n        width: 40px;\r\n        height: 45px;\r\n        min-width: auto;\r\n        max-width: none;\r\n    }\r\n\r\n    .value-component-image{\r\n        min-width: auto;\r\n        max-width: none;\r\n        width: 100%;\r\n        height: 100%;\r\n    }\r\n\r\n    .value-component-text-title{\r\n        margin-top: 5px;\r\n        font-size: 1.1em;\r\n    }\r\n\r\n    .value-component-text-description{\r\n        margin-top: 20px;\r\n        font-size: 1em;\r\n    }\r\n\r\n    #vm-button{\r\n        min-height: auto;\r\n        max-height: none;\r\n        height: 30px;\r\n        font-size: 1em;\r\n        /*background-color: '';*/\r\n    }\r\n\r\n    #company-info-button {\r\n        font-size: 0.8em;\r\n        height: 30px;\r\n    }\r\n    #projects-title{\r\n        font-size: 1.1em;\r\n        height: auto;\r\n    }\r\n    #feature-info-title{\r\n        font-size: 1.5em;\r\n        text-align: center;\r\n    }\r\n    #feature-info-sub-title{\r\n        font-size: 1.2em;\r\n        text-align: center;\r\n    }\r\n    .feature-info-image-description{\r\n        font-size: 1em;\r\n        margin-bottom: 10px;\r\n        color: #01483F;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
